// extracted by mini-css-extract-plugin
module.exports = {"card":"CharacterCard_card__33ZMf"};